export default {
    props: {
        dataEntity: {
            type: String,
            required: false,
        },
    },

    computed: {
        entity() {
            return this.dataEntity
        },
    },
}
